module.exports = __webpack_public_path__ + "445ee1f40219fd4946f2f3c64c6b423f.svg";